export default {
    state: {
        amount: null
    },

    mutations: {
        setAmount(state, content) {
            state.amount = content;
        }
    },

    getters: {
        getAmount(state) {
            return state.amount;
        }
    }
};
